import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import { SCTI_COUNTRY_IDS } from 'containers/FastCover/constants';
import { AsyncCreatable } from 'react-select';
import {
  makeSelectCountriesOfxSupported,
} from 'containers/FastCover/StepWhatHappened/selectors';

import injectReducer from 'utils/injectReducer';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import {
  makeSelectStepAppsureBankDetails,
  makeSelectStepAppsureBankDetailsErrors,
  makeSelectBsbValidating,
  makeSelectBsbNotice,
} from './selectors';
import reducer from './reducer';
import messages from './messages';

import WizardNavigationButtons from '../components/WizardNavigationButtons';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import Icon from '../../../components/Icon';
import { length, required, maxLength, alphaHyphenOnly, minLength } from '../../../utils/validation/validator';
import Textbox from '../components/Textbox/index';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation/';
import {
  handleFormDataChange,
  nextSlide,
  resetFormRegisterGstState,
  closeBSBNotice,
  resetTugoBankFields,
  resetFormDataAddress,
} from './actions';
import { makeSelectCellCaptiveCountryId, makeSelectPolicyTypeCode, makeSelectIsClaimForFieldEnabled, makeSelectIsShowGstQuestion, makeSelectCellCaptiveName, makeSelectFormHasChanges, makeSelectJSONVersion } from '../../App/selectors';
import { listPolicyTypeForCellCaptivePartnerInsurance } from '../../FastCover/dataMapper/claimCodeMapper';
import OptionsContainer from '../components/OptionsContainer';
import P from '../../../components/P/index';
import { saveFormData } from '../actions';
import { setFormHasChanges } from '../../App/actions';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { getBank, getBankSuccess, getCountryPaymentConfig } from '../../FastCover/actions';
import ModalNotice from './components/ModalNotice';
import InvalidBSBWarning from './components/InvalidBSBWarning';
import HelpText from '../../../components/HelpText';
import TextArea from '../components/TextArea';
import { LIST_CELLCAPTIVE_NAME } from '../../App/constants';
import MySelect from '../../../components/MySelect';
import {
  makeSelectTitleList,
} from '../../ClaimList/selectors';
import { TUGO_DEFAULT_COUNTRY } from './reducer';
import { appConfig } from '../../../configureApp';

const alphaOnly = (value) => {
  if (!value) return true;
  return /^[a-zA-Z\s]+$/.test(value.toString().trim());
};

const minLengthAllowEmpty = (len) => {
  function minLenWithEmpty(value) {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return minLength(len)(value);
  }
  return minLenWithEmpty;
};

const maxLengthAllowEmpty = (len) => {
  function maxLenWithEmpty(value) {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return maxLength(len)(value);
  }
  return maxLenWithEmpty;
};

export class StepAppsureBankDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      showModal: false,
      maskedAccountNumber: '',
      showAccountNumber: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.saveButtonId = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
    this.invalidBSBWarning = null;

    this.lastCheckingBSB = props.form.bsbNumber;
    const { bsbNumber = '', institutionNumber = '' } = props.form || {};
    this.lastCheckingTransitInstitution = `${institutionNumber || ''}${bsbNumber || ''}`;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }

    // Update masked account number when form data changes externally
    if (nextProps.form.accountNumber !== this.props.form.accountNumber) {
      this.setState({
        maskedAccountNumber: this.maskAccountNumber(nextProps.form.accountNumber),
      });
    }
  }

  componentDidMount() {
    // Initialize masked account number on mount
    const { accountNumber } = this.props.form;
    if (accountNumber) {
      this.setState({
        maskedAccountNumber: this.maskAccountNumber(accountNumber),
      });
    }
  }

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getBankByBsb = (event) => {
    // this.validatorGroup.checkValidation();
    // const isInvalid = this.validatorGroup.checkError('bsbNumber');
    // if (isInvalid === false) {
    const value = event.target.value;
    if (!value) {
      const bankInfo = {
        isBsbValid: false,
        nameOfBank: '',
        branch: '',
        institutionNumber: '',
        bsbCannotBeVerified: false,
      };
      this.props.getBankSuccess(bankInfo);
    } else if (this.lastCheckingBSB !== value) {
      this.lastCheckingBSB = event.target.value;
      this.props.onGetBankByBSB(this.lastCheckingBSB);
    }
    // }
  };

  getBankByTransitAndInstitution = (event) => {
    const { form } = this.props;
    const { name, value } = event.target;
    const currentBsbNumber = name === 'bsbNumber' ? value : form.bsbNumber;
    const currentInstitutionNumber = name === 'institutionNumber' ? value : form.institutionNumber;
    const combinedValue = `${currentInstitutionNumber || ''}${currentBsbNumber || ''}`;

    if (!currentBsbNumber || !currentInstitutionNumber) {
      const bankInfo = {
        isBsbValid: false,
        nameOfBank: '',
        branch: '',
        institutionNumber: '',
        bsbCannotBeVerified: false,
      };
      this.props.getBankSuccess(bankInfo);
      this.lastCheckingTransitInstitution = '';
      return;
    }

    // Check validation before calling API
    const isBsbNumberValid = currentBsbNumber && currentBsbNumber.length === 5;
    const isInstitutionNumberValid = currentInstitutionNumber && currentInstitutionNumber.length === 3;

    // Only call API if both fields pass validation
    if (isBsbNumberValid && isInstitutionNumberValid && this.lastCheckingTransitInstitution !== combinedValue) {
      this.lastCheckingTransitInstitution = combinedValue;
      this.props.onGetBankByBSB(this.lastCheckingTransitInstitution);
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.checkBSBValidation();
    this.handleFormDataSave();
    this.nextButton.focus();
    this.checkFormError();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(2);
  };

  /**
   * Masks account number to show only last 4 digits
   * Example: "123456789012" becomes "********9012"
   */
  maskAccountNumber = (value) => {
    if (!value) return '';
    const cleanValue = value.toString();
    if (cleanValue.length <= 4) {
      return cleanValue;
    }
    const last4 = cleanValue.slice(-4);
    const masked = '*'.repeat(cleanValue.length - 4) + last4;
    return masked;
  };

  /**
   * Toggles visibility of account number between masked and unmasked
   */
  toggleAccountNumberVisibility = () => {
    this.setState((prevState) => ({
      showAccountNumber: !prevState.showAccountNumber,
    }));
  };

  /**
   * Handles account number input for Canada (TuGo)
   * Stores the real value while displaying masked version
   */
  handleAccountNumberChange = (event) => {
    const inputValue = event.target.value;
    const currentAccountNumber = this.props.form.accountNumber || '';

    // If showing unmasked, handle as regular input
    if (this.state.showAccountNumber) {
      // Remove any non-digit characters
      const digitsOnly = inputValue.replace(/\D/g, '');

      this.props.onFormDataChange('form.accountNumber', digitsOnly);
      this.props.setFormHasChanges(true);

      this.setState({
        maskedAccountNumber: this.maskAccountNumber(digitsOnly),
      });
      return;
    }

    // Handle masked input
    const currentMasked = this.maskAccountNumber(currentAccountNumber);

    // If user is deleting (input is shorter than current masked value)
    if (inputValue.length < currentMasked.length) {
      const charsRemoved = currentMasked.length - inputValue.length;
      const newValue = currentAccountNumber.substring(0, currentAccountNumber.length - charsRemoved);

      this.props.onFormDataChange('form.accountNumber', newValue);
      this.props.setFormHasChanges(true);

      this.setState({
        maskedAccountNumber: this.maskAccountNumber(newValue),
      });
      return;
    }

    // If user is adding characters (input is longer than current masked value)
    if (inputValue.length > currentMasked.length) {
      // Extract only the newly added characters
      const additionalChars = inputValue.substring(currentMasked.length);
      // Keep only digits from the additional input
      const newDigits = additionalChars.replace(/\D/g, '');

      if (newDigits) {
        const newValue = currentAccountNumber + newDigits;

        this.props.onFormDataChange('form.accountNumber', newValue);
        this.props.setFormHasChanges(true);

        this.setState({
          maskedAccountNumber: this.maskAccountNumber(newValue),
        });
      } else {
        // If no valid digits were added, reset to current masked value
        this.setState({
          maskedAccountNumber: currentMasked,
        });
      }
      return;
    }

    // If length is the same but content changed (user tried to edit middle)
    // Reset to the current masked value to prevent editing in the middle
    if (inputValue !== currentMasked) {
      this.setState({
        maskedAccountNumber: currentMasked,
      });
    }
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  checkBSBValidation = () => {
    const { isBsbValid, bsbCannotBeVerified } = this.props.form;
    if (!isBsbValid && !bsbCannotBeVerified) {
      this.showModal();
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    // const errors = this.validatorGroup.getErrors();
    this.checkFormError();

    this.handleFormDataSave();
    this.props.next();
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  handleResetPartialFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  closeModal = () => {
    this.setState({ showModal: false });
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  renderRegisterdGSTPurpuseInfo = () => {
    const { isSummary, submitted, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const { registerForGSTPurpose, abn, percentageOfGST, claimITC } = isSummary
      ? this.summaryFormValue()
      : this.props.form;
    return (
      registerForGSTPurpose === 'true' && (
        <div>
          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="abn"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.whatIsYourABN}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="abn"
                  type="number"
                  placeholder=""
                  onChange={this.handleChange('form.abn')}
                  value={abn}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.whatIsYourABN) }}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className={'row'}>
            <div className={'col-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.claimITC} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={claimITC === 'true'}
                    onChange={this.handleChange('form.claimITC')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={claimITC === 'false'}
                    onChange={this.handleChange('form.claimITC')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>

          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="percentageOfGST"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.whatPercentageOfGST}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="percentageOfGST"
                  type="number"
                  onChange={this.handleChange('form.percentageOfGST')}
                  value={percentageOfGST}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.whatPercentageOfGST) }}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
        </div>
      )
    );
  };

  renderOtherInsuranceDetail() {
    const { isSummary, submitted, intl } = this.props;
    const { otherInsurance, provideDetails } = isSummary
      ? this.summaryFormValue()
      : this.props.form;
    const isReadOnly = submitted || isSummary;
    return (
      otherInsurance === 'true' && (
        <div className={'form-group'}>
          {/* <PageSectionHeader> */}
          {/* <FormattedMessage {...messages.ifYesPleaseProvideDetails} /> */}
          {/* </PageSectionHeader> */}
          <Validate
            name="provideDetails"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={provideDetails}
            fieldName={messages.ifYesPleaseProvideDetails}
          >
            <TextArea
              disabled={isReadOnly}
              name="provideDetails"
              type="text"
              onChange={this.handleChange('form.provideDetails')}
              value={provideDetails}
              isSummary={isSummary}
            />
            <ErrorMessage for="required">
              <FormattedMessage
                {...messages.isRequired}
                values={{ defaultMessage: intl.formatMessage(messages.ifYesPleaseProvideDetails) }}
              />
            </ErrorMessage>
          </Validate>
        </div>
      )
    );
  }

  renderBankDetailsForm() {
    const {
      isSummary,
      submitted,
      bsbValidating,
      cellCaptiveCountryId,
      policyTypeCode,
      isClaimForFieldEnabled,
      isShowGstQuestion,
      intl,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      nameOfBank,
      branch,
      bsbNumber,
      accountNumber,
      accountHolder,
      registerForGSTPurpose,
      otherInsurance,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { bsbCannotBeVerified, isBsbValid } = this.props.form;

    const isPartnerInsurance = listPolicyTypeForCellCaptivePartnerInsurance.includes(policyTypeCode);
    const isFnolNewZealand = cellCaptiveCountryId === SCTI_COUNTRY_IDS.NEW_ZEALAND || isPartnerInsurance;

    const isbsbNumber6Digits = length(6)(bsbNumber);

    const maxAccountNumberLength = isFnolNewZealand ? 10 : 9;
    const isAccountNumberTooLong = maxLength(maxAccountNumberLength)(accountNumber) === false;

    let isAccountNumberTooShort = false;
    if (isFnolNewZealand) {
      isAccountNumberTooShort = minLength(9)(accountNumber) === false;
    }

    const isInvalidAccountHolderFormat = alphaHyphenOnly(accountHolder) === false;
    const isAccountHolderTooLong = maxLength(32)(accountHolder) === false;

    const bsbNumberNZTooltip = messages.bsbNumberNZTooltip.defaultMessage;
    const accountNumberNZTooltip = messages.accountNumberNZTooltip.defaultMessage;
    return (
      <div>
        <div className={'row'}>
          <div className={'col'}>
            <P>
              <FormattedMessage {...messages.depositMessage} />
            </P>
            <P style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10 }}>
              <FormattedMessage {...messages.pleaseNote} />
            </P>
            <ul style={{ margin: 0 }}>
              <li>
                <FormattedMessage
                  {...messages.weCannotDepositIntoACreditCardAccount}
                />
              </li>
            </ul>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-8 form-group mb02'}>
            <Validate
              name="accountHolder"
              group={this.validatorGroup}
              validators={[required, alphaHyphenOnly, maxLength(32)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountHolder}
              tooltipContent={intl.formatMessage(messages.bankAccountNameTooltip)}
              tooltipDataFor={'accountHolderHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountHolder"
                type="text"
                onChange={this.handleChange('form.accountHolder')}
                value={accountHolder}
                placeholder={isFnolNewZealand ? messages.accountNamePlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountHolder) }}
                />
              </ErrorMessage>
            </Validate>
            {isAccountHolderTooLong ? (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.limitAccountNameCharacters} />
              </P>
            ) : isInvalidAccountHolderFormat && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.onlyAlphaHyphenAllowed} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="bsbNumber"
              group={this.validatorGroup}
              validators={[required, length(6)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={isFnolNewZealand ? messages.bsbNumberNZ : messages.bsbNumber}
              tooltipContent={isFnolNewZealand ? bsbNumberNZTooltip : null}
              tooltipDataFor={'bankCodeHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="bsbNumber"
                type="number"
                onlyNumber={true}
                onBlurCapture={this.getBankByBsb}
                onChange={this.handleChange('form.bsbNumber')}
                value={bsbNumber}
                placeholder={isFnolNewZealand ? messages.bsbNumberNZPlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                {/* &apos;BSB Number&apos; is required */}
                <FormattedMessage
                  {...messages.isRequired}
                  values={{
                    defaultMessage: intl.formatMessage(
                      isFnolNewZealand ? messages.bsbNumberNZ : messages.bsbNumber
                    ),
                  }}
                />
              </ErrorMessage>
              <ErrorMessage for="m_length">
                <FormattedMessage {...messages.bsbNumberLengthValidation} />
              </ErrorMessage>
            </Validate>
            {(!isbsbNumber6Digits && bsbNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage
                  {...messages.bsbNumberLengthValidation}
                  values={{ type: isFnolNewZealand ? messages.bsbNumberNZ.defaultMessage : messages.bsbNumber.defaultMessage }}
                />
              </P>
            )}
          </div>
          <div
            className={'col-md-8 form-group mb02'}
            style={{
              justifyContent: 'flex-end',
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <OptionsContainer>
              <input
                disabled={isReadOnly || isBsbValid || !bsbNumber}
                type="checkbox"
                name="bsbCannotBeVerified"
                checked={bsbCannotBeVerified}
                onChange={this.handleChange('form.bsbCannotBeVerified')}
              />
              <span>
                {isFnolNewZealand ? (
                  <FormattedMessage {...messages.bsbCannotBeVerifiedNZ} />
                ) : (
                  <FormattedMessage {...messages.bsbCannotBeVerified} />
                )}
              </span>
            </OptionsContainer>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="nameOfBank"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={nameOfBank}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.nameOfBank}
            >
              <Textbox
                disabled={
                  isReadOnly ||
                  isBsbValid ||
                  (!isBsbValid && !bsbCannotBeVerified)
                }
                name="nameOfBank"
                type="text"
                onChange={this.handleChange('form.nameOfBank')}
                value={nameOfBank}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.nameOfBank) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.branch} />
            </PageSectionHeader>
            <Textbox
              disabled={
                isReadOnly ||
                isBsbValid ||
                (!isBsbValid && !bsbCannotBeVerified)
              }
              name="branch"
              type="text"
              onChange={this.handleChange('form.branch')}
              value={branch}
            />
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="accountNumber"
              group={this.validatorGroup}
              validators={[required, maxLength(maxAccountNumberLength), ...isFnolNewZealand ? [minLength(9)] : []]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={isFnolNewZealand ? messages.accountNumberNZ : messages.accountNumber}
              tooltipContent={isFnolNewZealand ? accountNumberNZTooltip : null}
              tooltipDataFor={'accountNumberHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountNumber"
                type="number"
                onChange={this.handleChange('form.accountNumber')}
                value={accountNumber}
                onlyNumber
                placeholder={isFnolNewZealand ? messages.accountNumberNZPlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{
                    defaultMessage: intl.formatMessage(
                      isFnolNewZealand ? messages.accountNumberNZ : messages.accountNumber
                    ),
                  }}
                />
              </ErrorMessage>
            </Validate>
            {isAccountNumberTooLong && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage
                  {...messages.accountNumberLengthValidation}
                  values={{ maxLength: maxAccountNumberLength }}
                />
              </P>
            )}
            {(isAccountNumberTooShort && accountNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                {isFnolNewZealand ? (
                  <FormattedMessage {...messages.accountNumberNZLengthValidationWithSuffix} />
                ) : (
                  <FormattedMessage {...messages.accountNumberLengthValidationWithSuffix} />
                )}
              </P>
            )}
          </div>
        </div>

        {isShowGstQuestion && (<div>
          <div className={'row mt-3'}>
            <div className={'col-12 form-group mb02'}>
              <span style={{ fontWeight: 'bold', fontSize: '0.86em' }}>
                <FormattedMessage {...messages.GSTInfo} />
              </span>
            </div>
          </div>

          <div className={'row mb-2'}>
            <div className={'col-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouRegisteredForGTSPurposes} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={registerForGSTPurpose === 'true'}
                    onChange={this.handleChange('form.registerForGSTPurpose')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={registerForGSTPurpose === 'false'}
                    onChange={this.handleResetPartialFormState(
                      'form.registerForGSTPurpose',
                      this.props.onResetRegisterGstState
                    )}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        </div>)}

        {!isClaimForFieldEnabled && this.renderRegisterdGSTPurpuseInfo()}
        {!isClaimForFieldEnabled && (
          <div className={'form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.doYouHaveAnotherOtherInsurance} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'true'}
                  onChange={this.handleChange('form.otherInsurance')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'false'}
                  onChange={(event) => {
                    this.handleChange('form.otherInsurance')(event);
                    this.props.onFormDataChange('form.provideDetails', '');
                    this.props.setFormHasChanges(true);
                  }}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
            <HelpText>
              <FormattedMessage {...messages.exampleHomeContentsInsurance} />
            </HelpText>
          </div>
        )}
        {!isClaimForFieldEnabled && this.renderOtherInsuranceDetail()}
      </div>
    );
  }

  // === V2 Handler Methods ===

  handleChangeSelectPaymentTo = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    // Reset bank fields and default country to Canada on payment-to change
    this.props.onResetTugoBankFields();
    const country = {
      id: TUGO_DEFAULT_COUNTRY.id,
      label: TUGO_DEFAULT_COUNTRY.name,
      value: TUGO_DEFAULT_COUNTRY.name,
    };
    this.props.onFormDataChange('form.country', country);
  };

  handleChangePaymentViaCheck = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }

    this.props.onResetFormDataAddress();
    if (value) {
      this.props.onFormDataChange('form.paymentVia', 'Check');
    } else {
      const country = {
        id: TUGO_DEFAULT_COUNTRY.id,
        label: TUGO_DEFAULT_COUNTRY.name,
        value: TUGO_DEFAULT_COUNTRY.name,
      };
      this.props.onFormDataChange('form.country', country);
      this.props.onFormDataChange('form.paymentVia', 'EFT');
    }
    this.props.onFormDataChange(propertyName, value);
  };

  handleChangeCountry = (v) => {
    const { jsonVersion } = this.props;
    let countryId = 0;
    if (v && typeof v === 'object') {
      countryId = v === null ? 0 : v.id;
    } else {
      countryId = v === null ? 0 : v;
    }
    // Reset bank fields when country changes
    this.props.onResetTugoBankFields();
    this.props.onFormDataChange('form.country', v);
    if (countryId !== 0 && jsonVersion > 6) {
      this.props.getCountryPaymentConfig(countryId);
    }
  };

  loadCountry = (inputValue, callback) => {
    const { countryList } = this.props;
    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];
    const countryListFiltered = countries.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    setTimeout(() => {
      callback(countryListFiltered);
    }, 1000);
  };

  handleChangeTitle = (v) => {
    this.props.onFormDataChange('form.title', v);
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  isCanadaSelected = () => {
    const { country } = this.props.form;
    if (!country) return false;
    // Handle both Immutable Map and plain JS object
    let countryId;
    let countryName;
    if (typeof country.get === 'function') {
      countryId = country.get('id');
      countryName = country.get('label') || country.get('value');
    } else if (typeof country === 'object') {
      countryId = country.id;
      countryName = country.label || country.value;
    }
    // Match by id OR by name to handle different country list sources
    return countryId === TUGO_DEFAULT_COUNTRY.id ||
      (countryName && countryName.toLowerCase() === TUGO_DEFAULT_COUNTRY.name.toLowerCase());
  };

  // === V2 Sub-Render Methods ===

  renderTugoCanadaBankFields() {
    const { isSummary, submitted, bsbValidating, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      nameOfBank, branch, bsbNumber, institutionNumber, accountNumber, accountHolder,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { bsbCannotBeVerified, isBsbValid } = this.props.form;

    const isTransitNumberValidLength = length(5)(bsbNumber);
    const isInstitutionNumberValidLength = length(3)(institutionNumber);
    const maxAccountNumberLength = 12;
    const minAccountNumberLength = 7;
    const isAccountNumberTooLong = maxLength(maxAccountNumberLength)(accountNumber) === false;
    const isAccountNumberTooShort = minLength(minAccountNumberLength)(accountNumber) === false;

    const accountNumberRequired = () => required(this.props.form.accountNumber);
    const accountNumberMinLength = () => minLengthAllowEmpty(minAccountNumberLength)(this.props.form.accountNumber);
    const accountNumberMaxLength = () => maxLengthAllowEmpty(maxAccountNumberLength)(this.props.form.accountNumber);

    const isInvalidAccountHolderFormat = alphaOnly(accountHolder) === false;
    const isAccountHolderTooLong = maxLength(32)(accountHolder) === false;

    return (
      <div>
        <div className={'row'}>
          <div className={'col-md-8 form-group mb02'}>
            <Validate
              name="accountHolder"
              group={this.validatorGroup}
              validators={[required, alphaOnly, maxLength(32)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountHoldersName}
              tooltipContent={intl.formatMessage({ id: 'fastCover.stepAppsureBankDetails.bankAccountNameTooltip' })}
              tooltipDataFor={'accountHolderHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountHolder"
                type="text"
                onChange={this.handleChange('form.accountHolder')}
                value={accountHolder}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountHoldersName) }}
                />
              </ErrorMessage>
              <ErrorMessage for={alphaOnly}>
                <FormattedMessage {...messages.onlyAlphaCharactersAllowed} />
              </ErrorMessage>
            </Validate>
            {isAccountHolderTooLong ? (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.limitAccountNameCharacters} />
              </P>
            ) : isInvalidAccountHolderFormat && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.onlyAlphaCharactersAllowed} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="bsbNumber"
              group={this.validatorGroup}
              validators={[required, minLengthAllowEmpty(5), maxLengthAllowEmpty(5)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.transitNumber}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="bsbNumber"
                type="number"
                onBlurCapture={this.getBankByTransitAndInstitution}
                onChange={this.handleChange('form.bsbNumber')}
                value={bsbNumber}
                onlyNumber
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.transitNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {(!isTransitNumberValidLength && bsbNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.transitNumberValidation} />
              </P>
            )}
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="institutionNumber"
              group={this.validatorGroup}
              validators={[required, minLengthAllowEmpty(3), maxLengthAllowEmpty(3)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.institutionNumber}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="institutionNumber"
                type="number"
                onBlurCapture={this.getBankByTransitAndInstitution}
                onChange={this.handleChange('form.institutionNumber')}
                value={institutionNumber}
                onlyNumber
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.institutionNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {(!isInstitutionNumberValidLength && institutionNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.institutionNumberValidation} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 col-sm-6 form-group mb02 d-flex align-items-center" style={{ gap: 8 }}>
            <OptionsContainer style={{ marginBottom: 0 }}>
              <input
                disabled={isReadOnly || isBsbValid || !bsbNumber}
                type="checkbox"
                name="bsbCannotBeVerified"
                checked={bsbCannotBeVerified}
                onChange={this.handleChange('form.bsbCannotBeVerified')}
              />
              <span>
                <FormattedMessage {...messages.transitAndInstitutionCannotBeVerified} />
              </span>
            </OptionsContainer>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="nameOfBank"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={nameOfBank}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.nameOfBank}
            >
              <Textbox
                disabled={isReadOnly || isBsbValid || (!isBsbValid && !bsbCannotBeVerified)}
                name="nameOfBank"
                type="text"
                onChange={this.handleChange('form.nameOfBank')}
                value={nameOfBank}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.nameOfBank) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.branch} />
            </PageSectionHeader>
            <Textbox
              disabled={isReadOnly || isBsbValid || (!isBsbValid && !bsbCannotBeVerified)}
              name="branch"
              type="text"
              onChange={this.handleChange('form.branch')}
              value={branch}
            />
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="accountNumber"
              group={this.validatorGroup}
              validators={[accountNumberRequired, accountNumberMinLength, accountNumberMaxLength]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountNumber}
            >
              <input
                type="text"
                name="accountNumber"
                value={accountNumber || ''}
                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                tabIndex={-1}
                onChange={() => { }}
              />
              <div className="account-number-input-wrapper">
                <Textbox
                  disabled={isReadOnly}
                  name="accountNumberDisplay"
                  type="text"
                  onChange={this.handleAccountNumberChange}
                  value={this.state.showAccountNumber ? accountNumber : (this.state.maskedAccountNumber || this.maskAccountNumber(accountNumber))}
                />
                {accountNumber && (
                  <button
                    type="button"
                    className="account-number-toggle-button"
                    onClick={this.toggleAccountNumberVisibility}
                    disabled={isReadOnly}
                    title={this.state.showAccountNumber ? 'Hide account number' : 'Show account number'}
                    aria-label={this.state.showAccountNumber ? 'Hide account number' : 'Show account number'}
                  >
                    <Icon name={this.state.showAccountNumber ? 'fa-eye-slash' : 'fa-eye'} />
                  </button>
                )}
              </div>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {isAccountNumberTooShort && accountNumber && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.accountNumberMinValidation} />
              </P>
            )}
            {isAccountNumberTooLong && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.accountNumberMaxValidation} />
              </P>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderTrawickBankFields() {
    const { isSummary, submitted, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      bankTypeCode, bankCodeOrRoutingNumber, bank, bankAddress, bankSuburbOrCity,
      bankPostcode, bankBranch, bankAccountName, bankAccountNumber, swiftCode, iban,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    return (
      <div>
        <div className={'row'}>
          <div className={'col-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.bankTypeCode} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Bank Code"
                  checked={bankTypeCode === 'Bank Code'}
                  onChange={this.handleChange('form.bankTypeCode')}
                />
                <FormattedMessage {...messages.bankCode} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="SWIFT Code"
                  checked={bankTypeCode === 'SWIFT Code'}
                  onChange={this.handleChange('form.bankTypeCode')}
                />
                <FormattedMessage {...messages.swiftCode} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="IBAN"
                  checked={bankTypeCode === 'IBAN'}
                  onChange={this.handleChange('form.bankTypeCode')}
                />
                <FormattedMessage {...messages.IBANText} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>

        {bankTypeCode === 'SWIFT Code' && (
          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="swiftCode"
                validators={[required, maxLength(11)]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.swiftCode}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="swiftCode"
                  type="text"
                  onChange={this.handleChange('form.swiftCode')}
                  value={swiftCode}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.swiftCode) }}
                  />
                </ErrorMessage>
              </Validate>
              {maxLength(11)(swiftCode) === false && (
                <P style={{ color: 'red', fontSize: '0.7em' }}>
                  <FormattedMessage {...messages.isValidSwiftCode} />
                </P>
              )}
            </div>
          </div>
        )}

        {bankTypeCode === 'IBAN' && (
          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="iban"
                validators={[required, maxLength(34)]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.IBANText}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="iban"
                  type="text"
                  onChange={this.handleChange('form.iban')}
                  value={iban}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.IBANText) }}
                  />
                </ErrorMessage>
              </Validate>
              {maxLength(34)(iban) === false && (
                <P style={{ color: 'red', fontSize: '0.7em' }}>
                  <FormattedMessage {...messages.isValidIban} />
                </P>
              )}
              <P style={{ fontSize: '0.7em', color: '#666' }}>
                <FormattedMessage {...messages.reminderIban} />
              </P>
            </div>
          </div>
        )}

        {bankTypeCode === 'Bank Code' && (
          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="bankCodeOrRoutingNumber"
                validators={[required, maxLength(32)]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.bankCodeOrRoutingNumber}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="bankCodeOrRoutingNumber"
                  type="text"
                  onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                  value={bankCodeOrRoutingNumber}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.bankCodeOrRoutingNumber) }}
                  />
                </ErrorMessage>
              </Validate>
              {maxLength(32)(bankCodeOrRoutingNumber) === false && (
                <P style={{ color: 'red', fontSize: '0.7em' }}>
                  <FormattedMessage {...messages.isValidBankCode} />
                </P>
              )}
            </div>
          </div>
        )}

        <div className={'row'}>
          <div className={'col-md-5 form-group'}>
            <Validate
              name="bankAccountName"
              validators={[required, maxLength(128)]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bankAccountName}
            >
              <Textbox
                disabled={isReadOnly}
                name="bankAccountName"
                type="text"
                onChange={this.handleChange('form.bankAccountName')}
                value={bankAccountName}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.bankAccountName) }}
                />
              </ErrorMessage>
            </Validate>
            {maxLength(128)(bankAccountName) === false && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.isValidBankAccountName} />
              </P>
            )}
          </div>
          <div className={'col-md-5 form-group'}>
            <Validate
              name="bankAccountNumber"
              validators={[required, maxLength(17)]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bankAccountNumber}
            >
              <Textbox
                disabled={isReadOnly}
                name="bankAccountNumber"
                type="text"
                onChange={this.handleChange('form.bankAccountNumber')}
                value={bankAccountNumber}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.bankAccountNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {maxLength(17)(bankAccountNumber) === false && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.isValidAccountNumber} />
              </P>
            )}
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-5 form-group'}>
            <Validate
              name="bank"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bankName}
            >
              <Textbox
                disabled={isReadOnly}
                name="bank"
                type="text"
                onChange={this.handleChange('form.bank')}
                value={bank}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.bankName) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col form-group'}>
            <Validate
              name="bankBranch"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bankBranchName}
            >
              <Textbox
                disabled={isReadOnly}
                name="bankBranch"
                type="text"
                onChange={this.handleChange('form.bankBranch')}
                value={bankBranch}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.bankBranchName) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col form-group'}>
            <Validate
              name="bankAddress"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bankAddress}
            >
              <Textbox
                disabled={isReadOnly}
                name="bankAddress"
                type="text"
                onChange={this.handleChange('form.bankAddress')}
                value={bankAddress}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.bankAddress) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-6 form-group'}>
            <Validate
              name="bankSuburbOrCity"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bankSuburbOrCity}
            >
              <Textbox
                disabled={isReadOnly}
                name="bankSuburbOrCity"
                type="text"
                onChange={this.handleChange('form.bankSuburbOrCity')}
                value={bankSuburbOrCity}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.bankSuburbOrCity) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 form-group'}>
            <Validate
              name="bankPostcode"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.bankPostcode}
            >
              <Textbox
                disabled={isReadOnly}
                name="bankPostcode"
                type="text"
                onChange={this.handleChange('form.bankPostcode')}
                value={bankPostcode}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.bankPostcode) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      </div>
    );
  }

  renderCheckFields() {
    const { isSummary, submitted, intl, titleList, countryList } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      title, firstName, lastName, addressLine1, addressLine2,
      city, state: formState, postalZipCode, mobile, country,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    const titles = titleList && typeof titleList.toJS === 'function'
      ? titleList.toJS()
      : titleList || [];

    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];

    const countryValue = !!country && typeof country.toJS === 'function' ? country.toJS() : country;

    return (
      <div>
        {/* Title + First Name + Last Name */}
        <div className={'row'}>
          <div className={'col-md-4 form-group'}>
            <Validate
              name="checkTitle"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.title}
            >
              <MySelect
                disabled={isReadOnly}
                name="title"
                dataList={titles}
                value={title}
                onChange={this.handleChangeTitle}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.title) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 form-group'}>
            <Validate
              name="firstName"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.firstName}
            >
              <Textbox
                disabled={isReadOnly}
                name="firstName"
                type="text"
                onChange={this.handleChange('form.firstName')}
                value={firstName}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.firstName) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 form-group'}>
            <Validate
              name="lastName"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.lastName}
            >
              <Textbox
                disabled={isReadOnly}
                name="lastName"
                type="text"
                onChange={this.handleChange('form.lastName')}
                value={lastName}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.lastName) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        {/* Address Line 1 - full width */}
        <div className={'row'}>
          <div className={'col form-group'}>
            <Validate
              name="addressLine1"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.addressLine1}
            >
              <Textbox
                disabled={isReadOnly}
                name="addressLine1"
                type="text"
                onChange={this.handleChange('form.addressLine1')}
                value={addressLine1}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.addressLine1) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        {/* Address Line 2 - full width */}
        <div className={'row'}>
          <div className={'col form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.addressLine2} />
            </PageSectionHeader>
            <Textbox
              disabled={isReadOnly}
              name="addressLine2"
              type="text"
              onChange={this.handleChange('form.addressLine2')}
              value={addressLine2}
            />
          </div>
        </div>

        {/* City + State + Country */}
        <div className={'row'}>
          <div className={'col-md-3 form-group'}>
            <Validate
              name="city"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.city}
            >
              <Textbox
                disabled={isReadOnly}
                name="city"
                type="text"
                onChange={this.handleChange('form.city')}
                value={city}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.city) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-3 form-group'}>
            <Validate
              name="checkState"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.state}
            >
              <Textbox
                disabled={isReadOnly}
                name="state"
                type="text"
                onChange={this.handleChange('form.state')}
                value={formState}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.state) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 form-group'}>
            <Validate
              name="checkCountry"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.country}
            >
              <AsyncCreatable
                loadOptions={this.loadCountry}
                name="checkCountry"
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  input: (styles) => ({ ...styles, border: 'none !important' }),
                }}
                value={countryValue}
                placeholder="Type a country"
                isClearable
                isDisabled={isReadOnly}
                onChange={(e) => {
                  this.props.onFormDataChange('form.country', e);
                }}
                defaultOptions={countries}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.country) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        {/* Postal/Zip Code + Mobile */}
        <div className={'row'}>
          <div className={'col-md-3 form-group'}>
            <Validate
              name="postalZipCode"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.postalZipCode}
            >
              <Textbox
                disabled={isReadOnly}
                name="postalZipCode"
                type="text"
                onChange={this.handleChange('form.postalZipCode')}
                value={postalZipCode}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.postalZipCode) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-3 form-group'}>
            <Validate
              name="mobile"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.mobile}
            >
              <Textbox
                disabled={isReadOnly}
                name="mobile"
                type="text"
                onChange={this.handleChangePhoneNumber('form.mobile')}
                value={mobile}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.mobile) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      </div>
    );
  }

  renderTugoBankDetailsFormV2() {
    const { isSummary, submitted, intl, countryList } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      paymentTo, country, isCheckPayment,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];

    const countryValue = !!country && typeof country.toJS === 'function' ? country.toJS() : country;
    const isCanada = this.isCanadaSelected();

    return (
      <div>
        {/* Payment Options Header */}
        <div className={'row mt-3'}>
          <div className={'col-12'}>
            <span style={{ fontWeight: 'bold', fontSize: '0.86em' }}>
              <FormattedMessage {...messages.paymentOptions} />
            </span>
          </div>
        </div>

        {/* Payment To Radio Buttons */}
        <div className={'row'}>
          <div className={'col-12 form-group'}>
            <PageSectionHeader>
              <span style={{ fontWeight: 'bold', fontSize: '0.86em' }}>
                <FormattedMessage {...messages.paymentTo} />
              </span>
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Member"
                  checked={paymentTo === 'Member'}
                  onChange={this.handleChangeSelectPaymentTo('form.paymentTo')}
                />
                <FormattedMessage {...messages.memberInsured} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Family Member"
                  checked={paymentTo === 'Family Member'}
                  onChange={this.handleChangeSelectPaymentTo('form.paymentTo')}
                />
                <FormattedMessage {...messages.familyMember} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Provider"
                  checked={paymentTo === 'Provider'}
                  onChange={this.handleChangeSelectPaymentTo('form.paymentTo')}
                />
                <FormattedMessage {...messages.provider} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>

        {/* Country Selector */}
        {!isCheckPayment && (
          <div className={'row'}>
            <div className={'col-md-7 form-group'}>
              <Validate
                name="country"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                fieldName={messages.country}
              >
                <AsyncCreatable
                  loadOptions={this.loadCountry}
                  name="country"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    input: (styles) => ({ ...styles, border: 'none !important' }),
                  }}
                  value={countryValue}
                  placeholder="Type a country"
                  isClearable
                  isDisabled={isReadOnly}
                  onChange={(e) => {
                    this.handleChangeCountry(e);
                  }}
                  defaultOptions={countries}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage(messages.country) }}
                  />
                </ErrorMessage>
              </Validate>
              {/* <P style={{ fontSize: '0.7em', color: '#666' }}>
                <FormattedMessage {...messages.confirmSelectCountry} />
              </P> */}
            </div>
          </div>
        )}

        {/* Bank Fields: Canada or Trawick depending on selected country */}
        {!isCheckPayment && (
          <div>
            {isCanada ? this.renderTugoCanadaBankFields() : this.renderTrawickBankFields()}
          </div>
        )}

        {/* Check Address Fields */}
        {isCheckPayment && this.renderCheckFields()}

        {/* Check Payment Checkbox - always at the bottom */}
        <div className={'row mt-3'}>
          <div className={'col-12 form-group'}>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="isCheckPayment"
                checked={isCheckPayment}
                onChange={this.handleChangePaymentViaCheck('form.isCheckPayment')}
              />
              <span style={{ fontSize: '0.86em' }}>
                <FormattedMessage {...messages.alternativelyText} />
              </span>
            </OptionsContainer>
          </div>
        </div>
      </div>
    );
  }

  renderTugoBankDetailsForm() {
    const {
      isSummary,
      submitted,
      bsbValidating,
      cellCaptiveCountryId,
      policyTypeCode,
      isClaimForFieldEnabled,
      isShowGstQuestion,
      intl,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      nameOfBank,
      branch,
      bsbNumber,
      institutionNumber,
      accountNumber,
      accountHolder,
      registerForGSTPurpose,
      otherInsurance,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { bsbCannotBeVerified, isBsbValid } = this.props.form;

    const isPartnerInsurance = listPolicyTypeForCellCaptivePartnerInsurance.includes(policyTypeCode);
    const isFnolNewZealand = cellCaptiveCountryId === SCTI_COUNTRY_IDS.NEW_ZEALAND || isPartnerInsurance;

    const isTransitNumberValidLength = length(5)(bsbNumber);
    const isInstitutionNumberValidLength = length(3)(institutionNumber);

    const maxAccountNumberLength = 12;
    const minAccountNumberLength = 7;
    const isAccountNumberTooLong = maxLength(maxAccountNumberLength)(accountNumber) === false;
    const isAccountNumberTooShort = minLength(minAccountNumberLength)(accountNumber) === false;

    // Custom validators that read from form state instead of input value
    const accountNumberRequired = (value) => {
      // Always validate against actual account number from form state
      return required(this.props.form.accountNumber);
    };

    const accountNumberMinLength = (value) => {
      return minLengthAllowEmpty(minAccountNumberLength)(this.props.form.accountNumber);
    };

    const accountNumberMaxLength = (value) => {
      return maxLengthAllowEmpty(maxAccountNumberLength)(this.props.form.accountNumber);
    };

    const isInvalidAccountHolderFormat = alphaOnly(accountHolder) === false;
    const isAccountHolderTooLong = maxLength(32)(accountHolder) === false;

    const bsbNumberNZTooltip =
      'The first 6 digits of your bank account which captures your bank`s prefix and branch number (e.g. 123113).';
    const accountNumberNZTooltip =
      'Your unique number and suffix (usually 9-10 digits)';
    return (
      <div>
        <div className={'row'}>
          <div className={'col'}>
            <P>
              <FormattedMessage {...messages.depositMessage} />
            </P>
            <P style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10 }}>
              <FormattedMessage {...messages.pleaseNote} />
            </P>
            <ul style={{ margin: 0 }}>
              <li>
                <FormattedMessage
                  {...messages.weCannotDepositIntoACreditCardAccount}
                />
              </li>
            </ul>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-8 form-group mb02'}>
            <Validate
              name="accountHolder"
              group={this.validatorGroup}
              validators={[required, alphaOnly, maxLength(32)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountHoldersName}
              tooltipContent={intl.formatMessage({ id: 'fastCover.stepAppsureBankDetails.bankAccountNameTooltip' })}
              tooltipDataFor={'accountHolderHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly}
                name="accountHolder"
                type="text"
                onChange={this.handleChange('form.accountHolder')}
                value={accountHolder}
                placeholder={isFnolNewZealand ? messages.accountNamePlaceholder.defaultMessage : null}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountHoldersName) }}
                />
              </ErrorMessage>
              <ErrorMessage for={alphaOnly}>
                <FormattedMessage {...messages.onlyAlphaCharactersAllowed} />
              </ErrorMessage>
            </Validate>
            {isAccountHolderTooLong ? (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.limitAccountNameCharacters} />
              </P>
            ) : isInvalidAccountHolderFormat && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.onlyAlphaCharactersAllowed} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="bsbNumber"
              group={this.validatorGroup}
              validators={[required, minLengthAllowEmpty(5), maxLengthAllowEmpty(5)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.transitNumber}
              tooltipContent={isFnolNewZealand ? bsbNumberNZTooltip : null}
              tooltipDataFor={'bankCodeHint'}
              tooltipPlace={'right'}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="bsbNumber"
                type="number"
                onBlurCapture={this.getBankByTransitAndInstitution}
                onChange={this.handleChange('form.bsbNumber')}
                value={bsbNumber}
                placeholder={isFnolNewZealand ? messages.bsbNumberNZPlaceholder.defaultMessage : null}
                onlyNumber
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.transitNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {(!isTransitNumberValidLength && bsbNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.transitNumberValidation} />
              </P>
            )}
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="institutionNumber"
              group={this.validatorGroup}
              validators={[required, minLengthAllowEmpty(3), maxLengthAllowEmpty(3)]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.institutionNumber}
            >
              <Textbox
                disabled={isReadOnly || bsbValidating}
                name="institutionNumber"
                type="number"
                onBlurCapture={this.getBankByTransitAndInstitution}
                onChange={this.handleChange('form.institutionNumber')}
                value={institutionNumber}
                onlyNumber
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.institutionNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {(!isInstitutionNumberValidLength && institutionNumber) && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.institutionNumberValidation} />
              </P>
            )}
          </div>
        </div>

        <div className="row">
          <div
            className="col-md-6 col-sm-6 form-group mb02 d-flex align-items-center"
            style={{ gap: 8 }}
          >
            <OptionsContainer style={{ marginBottom: 0 }}>
              <input
                disabled={isReadOnly || isBsbValid || !bsbNumber}
                type="checkbox"
                name="bsbCannotBeVerified"
                checked={bsbCannotBeVerified}
                onChange={this.handleChange('form.bsbCannotBeVerified')}
              />
              <span>
                <FormattedMessage {...messages.transitAndInstitutionCannotBeVerified} />
              </span>
            </OptionsContainer>
          </div>
        </div>

        <div className={'row'}>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="nameOfBank"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={nameOfBank}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.nameOfBank}
            >
              <Textbox
                disabled={
                  isReadOnly ||
                  isBsbValid ||
                  (!isBsbValid && !bsbCannotBeVerified)
                }
                name="nameOfBank"
                type="text"
                onChange={this.handleChange('form.nameOfBank')}
                value={nameOfBank}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.nameOfBank) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.branch} />
            </PageSectionHeader>
            <Textbox
              disabled={
                isReadOnly ||
                isBsbValid ||
                (!isBsbValid && !bsbCannotBeVerified)
              }
              name="branch"
              type="text"
              onChange={this.handleChange('form.branch')}
              value={branch}
            />
          </div>
        </div>

        <div className="row">
          <div className={'col-md-4 col-sm-6 form-group mb02'}>
            <Validate
              name="accountNumber"
              group={this.validatorGroup}
              validators={[accountNumberRequired, accountNumberMinLength, accountNumberMaxLength]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              fieldName={messages.accountNumber}
              tooltipContent={isFnolNewZealand ? accountNumberNZTooltip : null}
              tooltipDataFor={'accountNumberHint'}
              tooltipPlace={'right'}
            >
              {/* Hidden input for validation - must be first child, contains actual account number */}
              <input
                type="text"
                name="accountNumber"
                value={accountNumber || ''}
                style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                tabIndex={-1}
                onChange={() => { }} // No-op to allow Validate component to track changes
              />
              <div className="account-number-input-wrapper">
                <Textbox
                  disabled={isReadOnly}
                  name="accountNumberDisplay"
                  type="text"
                  onChange={this.handleAccountNumberChange}
                  value={this.state.showAccountNumber ? accountNumber : (this.state.maskedAccountNumber || this.maskAccountNumber(accountNumber))}
                  placeholder={isFnolNewZealand ? messages.accountNumberNZPlaceholder.defaultMessage : null}
                />
                {accountNumber && (
                  <button
                    type="button"
                    className="account-number-toggle-button"
                    onClick={this.toggleAccountNumberVisibility}
                    disabled={isReadOnly}
                    title={this.state.showAccountNumber ? 'Hide account number' : 'Show account number'}
                    aria-label={this.state.showAccountNumber ? 'Hide account number' : 'Show account number'}
                  >
                    <Icon name={this.state.showAccountNumber ? 'fa-eye-slash' : 'fa-eye'} />
                  </button>
                )}
              </div>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage(messages.accountNumber) }}
                />
              </ErrorMessage>
            </Validate>
            {isAccountNumberTooShort && accountNumber && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.accountNumberMinValidation} />
              </P>
            )}
            {isAccountNumberTooLong && (
              <P style={{ color: 'red', fontSize: '0.7em' }}>
                <FormattedMessage {...messages.accountNumberMaxValidation} />
              </P>
            )}
          </div>
        </div>

        {isShowGstQuestion && (<div>
          <div className={'row mt-3'}>
            <div className={'col-12 form-group mb02'}>
              <span style={{ fontWeight: 'bold', fontSize: '0.86em' }}>
                <FormattedMessage {...messages.GSTInfo} />
              </span>
            </div>
          </div>

          <div className={'row mb-2'}>
            <div className={'col-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouRegisteredForGTSPurposes} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={registerForGSTPurpose === 'true'}
                    onChange={this.handleChange('form.registerForGSTPurpose')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={registerForGSTPurpose === 'false'}
                    onChange={this.handleResetPartialFormState(
                      'form.registerForGSTPurpose',
                      this.props.onResetRegisterGstState
                    )}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        </div>)}

        {!isClaimForFieldEnabled && this.renderRegisterdGSTPurpuseInfo()}
        {!isClaimForFieldEnabled && (
          <div className={'form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.doYouHaveAnotherOtherInsurance} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'true'}
                  onChange={this.handleChange('form.otherInsurance')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={otherInsurance === 'false'}
                  onChange={(event) => {
                    this.handleChange('form.otherInsurance')(event);
                    this.props.onFormDataChange('form.provideDetails', '');
                    this.props.setFormHasChanges(true);
                  }}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
            <HelpText>
              <FormattedMessage {...messages.exampleHomeContentsInsurance} />
            </HelpText>
          </div>
        )}
        {!isClaimForFieldEnabled && this.renderOtherInsuranceDetail()}
      </div>
    );
  }

  render() {
    const {
      isSummary,
      submitted,
      loading,
      showBSBNotice,
      cellCaptiveCountryId,
      policyTypeCode,
      cellCaptiveName,
      intl,
    } = this.props;
    const { showModal } = this.state;
    const isPartnerInsurance = listPolicyTypeForCellCaptivePartnerInsurance.includes(policyTypeCode);
    const isFnolNewZealand = cellCaptiveCountryId === SCTI_COUNTRY_IDS.NEW_ZEALAND || isPartnerInsurance;
    const isVisitorsToCanada = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_VISITORS_TO_CANADA;
    const isTugoStudentPolicy = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_IA_TUGO_STUDENT
      || cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_TUGO_CANADIAN_STUDENT;
    return (
      <div className="app-content">
        {(isVisitorsToCanada || isTugoStudentPolicy)
          ? (appConfig.canadaBankDetails ? this.renderTugoBankDetailsFormV2() : this.renderTugoBankDetailsForm())
          : this.renderBankDetailsForm()}
        {!isSummary && (
          <WizardNavigationButtons
            onBack={this.props.prev}
            onNext={this.handleNext}
            onSave={this.handleSaveButtonClick}
            canMoveNext={true}
            listLength={1}
            submitted={submitted}
            loading={loading}
            saveButtonId={this.saveButtonId}
            showSpinnerForElement={this.showSpinnerForElement}
            handleKeyDown={this.handleKeyDown}
            intl={intl}
            hasFormChanges={this.props.hasFormChanges}
            nextButtonRef={(ref) => {
              this.nextButton = ref;
            }}
          />
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
        <ModalNotice
          isFnolNewZealand={isFnolNewZealand}
          isOpen={showBSBNotice}
          onClose={this.props.closeBSBNotice}
          useTransitNotice={isVisitorsToCanada}
        />
        <InvalidBSBWarning isOpen={showModal} onClose={this.closeModal} />
      </div>
    );
  }
}

StepAppsureBankDetails.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  onResetRegisterGstState: PropTypes.func,
  currentStep: PropTypes.number,
  step: PropTypes.number,
  isReadOnly: PropTypes.bool,
  loading: PropTypes.bool,
  errors: PropTypes.array,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  submitted: PropTypes.bool,
  isSummary: PropTypes.bool,
  bsbValidating: PropTypes.bool,
  onGetBankByBSB: PropTypes.func,
  showBSBNotice: PropTypes.bool,
  closeBSBNotice: PropTypes.func,
  getBankSuccess: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  cellCaptiveCountryId: PropTypes.number,
  policyTypeCode: PropTypes.string,
  isClaimForFieldEnabled: PropTypes.bool,
  isShowGstQuestion: PropTypes.bool,
  cellCaptiveName: PropTypes.string,
  intl: intlShape.isRequired,
  countryList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  titleList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  jsonVersion: PropTypes.number,
  onResetTugoBankFields: PropTypes.func,
  onResetFormDataAddress: PropTypes.func,
  getCountryPaymentConfig: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  currentStep: makeSelectCurrentStep(),
  form: makeSelectStepAppsureBankDetails(),
  errors: makeSelectStepAppsureBankDetailsErrors(),
  loading: makeSelectProgressBarStatus(),
  bsbValidating: makeSelectBsbValidating(),
  showBSBNotice: makeSelectBsbNotice(),
  cellCaptiveCountryId: makeSelectCellCaptiveCountryId(),
  policyTypeCode: makeSelectPolicyTypeCode(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  isShowGstQuestion: makeSelectIsShowGstQuestion(),
  cellCaptiveName: makeSelectCellCaptiveName(),
  hasFormChanges: makeSelectFormHasChanges(),
  countryList: makeSelectCountriesOfxSupported(),
  titleList: makeSelectTitleList(),
  jsonVersion: makeSelectJSONVersion(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetRegisterGstState: () => dispatch(resetFormRegisterGstState()),
  onGetBankByBSB: (bsb) => dispatch(getBank(bsb)),
  closeBSBNotice: () => dispatch(closeBSBNotice()),
  getBankSuccess: (bankInfo) => dispatch(getBankSuccess(bankInfo)),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
  onResetTugoBankFields: () => dispatch(resetTugoBankFields()),
  onResetFormDataAddress: () => dispatch(resetFormDataAddress()),
  getCountryPaymentConfig: (countryId) => dispatch(getCountryPaymentConfig(countryId)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepAppsureBankDetails', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(StepAppsureBankDetails);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/index.js